import React, { useEffect, useRef, useState } from "react";
import L, { LatLngTuple, Map } from "leaflet";
import { MapContainer, TileLayer, ZoomControl, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { EntTerritorialsUnits } from '../../../models/handBooks/territorialsUnits';
import { ApiResponse, KurultaiAllDataResponse, KurultaiResponse, KurultaiRegister, Assignment, Task, Event, RegionData, CategoryData } from '../api/types';
import styles from "./styles.module.css";
import { Select } from "antd";

interface IContentPart {
  latitude: number;
  longitude: number;
  polygonsData: any;
  data: any;
  areaData: any;
  onRegionClick: (value: number, option: any) => void;
  selectedRegionName: string;
  selectedRegionId: number | null;
  polygonsLoading: boolean;
}

interface PopupContentProps {
  item: KurultaiRegister;
  onShowMore: (item: KurultaiRegister) => void;
}

const PopupContent = ({ item, onShowMore }: PopupContentProps) => {
  const firstAssignment = item.assignmentsList[0];
  const firstEvent = firstAssignment?.tasksList[0]?.eventsList[0];

  return (
    <div style={{ padding: '10px' }}>
      <div style={{ marginBottom: '8px' }}>
        <span style={{
          display: 'inline-block',
          marginRight: '8px',
          color: '#666',
          fontSize: '14px'
        }}>
          <img src="/assets/icons_kurultai/fio.svg" style={{ width: '20px', height: '20px' }} /> ФИО делегата:
        </span>
        <span style={{
          color: '#000',
          fontSize: '14px'
        }}>
          {item.delegateName}
        </span>
      </div>

      {firstAssignment && (
        <>
          <div style={{ marginBottom: '8px' }}>
            <span style={{
              display: 'inline-block',
              marginRight: '8px',
              color: '#666',
              fontSize: '14px'
            }}>
              <img src="/assets/icons_kurultai/que.svg" style={{ width: '20px', height: '20px' }} /> Вопрос:
            </span>
            <span style={{
              color: '#000',
              fontSize: '14px'
            }}>
              {firstAssignment.question}
            </span>
          </div>

          <div style={{ marginBottom: '8px' }}>
            <span style={{
              display: 'inline-block',
              marginRight: '8px',
              color: '#666',
              fontSize: '14px'
            }}>
              <img src="/assets/icons_kurultai/time.svg" style={{ width: '20px', height: '20px' }} /> Срок исполнения:
            </span>
            <span style={{
              color: '#000',
              fontSize: '14px'
            }}>
              {firstEvent?.deadlineDate || 'Не указан'}
            </span>
          </div>

          <div style={{ marginBottom: '8px' }}>
            <span style={{
              display: 'inline-block',
              marginRight: '8px',
              color: '#666',
              fontSize: '14px'
            }}>
              <img src="/assets/icons_kurultai/percent.svg" style={{ width: '20px', height: '20px' }} /> % исполнения:
            </span>
            <span style={{
              color: '#000',
              fontSize: '14px'
            }}>
              {firstAssignment.completionPercentage}%
            </span>
          </div>

          <div style={{ marginBottom: '12px' }}>
            <span style={{
              display: 'inline-block',
              marginRight: '8px',
              color: '#666',
              fontSize: '14px'
            }}>
              <img src="/assets/icons_kurultai/organ.svg" style={{ width: '20px', height: '20px' }} /> Ответственный орган:
            </span>
            <span style={{
              color: '#000',
              fontSize: '14px'
            }}>
              {firstEvent?.responsibleAuthority || 'Не указан'}
            </span>
          </div>
        </>
      )}

      <button
        onClick={() => onShowMore(item)}
        style={{
          display: 'inline-block',
          width: '100%',
          marginTop: '5px',
          padding: '8px 16px',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '20px',
          cursor: 'pointer',
          textAlign: 'center',
          textDecoration: 'none',
          fontSize: '14px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
      >
        Подробнее
      </button>
    </div>
  );
};

const DetailContent = ({ item }: { item: KurultaiRegister }) => (
  <div>
    <div style={{ borderBottom: '2px solid #2196F3', paddingBottom: '10px', marginBottom: '10px' }}>
      <h3 style={{ color: '#1976D2', margin: '0 0 10px 0' }}>Делегат: {item.delegateName}</h3>
      <p><strong>Номер собрания:</strong> {item.assemblyNumber}</p>
      <p><strong>Дата собрания:</strong> {item.assemblyDate}</p>
      <p><strong>Регион:</strong> {item.region.nameRu} ({item.region.code})</p>
      <p><strong>Район:</strong> {item.area.nameRu} ({item.area.code})</p>
      <p><strong>Территориальная единица:</strong> {item.territorialUnit.nameRu}</p>
      {/* <p><strong>Координаты:</strong> [{item.latitude}, {item.longitude}]</p> */}
      <p><strong>Дата создания:</strong> {item.createdTime}</p>
    </div>

    <div style={{ marginTop: '15px' }}>
      <h4 style={{ color: '#1976D2', marginBottom: '10px' }}>Задания ({item.assignmentsList.length})</h4>
      {item.assignmentsList.map((assignment: Assignment) => (
        <div key={assignment.id} style={{
          marginBottom: '20px',
          padding: '10px',
          border: '1px solid #E0E0E0',
          borderRadius: '4px',
          backgroundColor: '#F5F5F5'
        }}>
          <div style={{ marginBottom: '10px' }}>
            <p><strong>Категория:</strong> {assignment.questionCategory.nameRu}</p>
            <p><strong>Вопрос:</strong> {assignment.question}</p>
            <p><strong>Описание:</strong> {assignment.questionDescription}</p>
            <p><strong>Источник финансирования:</strong> {assignment.sourceOfFunding}</p>
        
            <p><strong>Процент выполнения:</strong> {assignment.completionPercentage}%</p>
            <p><strong>Дата создания:</strong> {assignment.createdTime}</p>
          </div>

          {assignment.tasksList.map((task: Task) => (
            <div key={task.id} style={{
              margin: '10px 0',
              padding: '10px',
              backgroundColor: 'white',
              borderRadius: '4px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
            }}>
              <p><strong>Задача:</strong> {task.description}</p>
              <p><strong>Процент выполнения:</strong> {task.completionPercentage}% вып.поруч.</p>

              <div style={{ marginTop: '10px' }}>
                {task.eventsList.map((event: Event) => (
                  <div key={event.id} style={{
                    margin: '5px 0',
                    padding: '8px',
                    backgroundColor: '#E3F2FD',
                    borderRadius: '4px'
                  }}>
                    <p><strong>Индикатор:</strong> {event.indicator}</p>
                    <p><strong>Срок:</strong> {event.deadlineDate}</p>
                    <p><strong>Статус:</strong> {event.kurultaiStatus.nameRu}</p>
                    <p><strong>Ответственный орган:</strong> {event.responsibleAuthority}</p>
                    {event.eventDetails && (
                      <p style={{ marginTop: '8px' }}><strong>Детали мероприятия:</strong> {event.eventDetails}</p>
                    )}
                    <p><strong>Последнее обновление:</strong> {event.editedTime || event.createdTime}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
);

interface RightTableProps {
  data: ApiResponse<KurultaiResponse>;
  onRegionClick: (value: number, option: any) => void;
  selectedRegionId: number | null;
  polygonsLoading: boolean;
  polygonsData: any;
}

const RightTableComponent: React.FC<RightTableProps> = ({
  data,
  onRegionClick,
  selectedRegionId,
  polygonsLoading,
  polygonsData
}) => {
  const [expandedAreas, setExpandedAreas] = useState<{ [key: string]: boolean }>({});

  const toggleArea = (areaName: string) => {
    setExpandedAreas(prev => ({
      ...prev,
      [areaName]: !prev[areaName]
    }));
  };

  if (!data?.res?.data?.length) {
    return (
      <div className={styles.rightTableContainer}>
        <div className={styles.title}>Данные по районам</div>
        <Select
          placeholder="Выберите регион"
          style={{ width: "100%" }}
          onChange={onRegionClick}
          value={selectedRegionId || undefined}
          loading={polygonsLoading}
        >
          <Select.Option value={0}>Все регионы</Select.Option>
          {(polygonsData?.res as EntTerritorialsUnits[])?.map((region: EntTerritorialsUnits) => (
            <Select.Option key={region.id} value={region.id} label={region.nameRu}>
              {region.nameRu}
            </Select.Option>
          ))}
        </Select>
        <div className={styles.totalCount}>Всего задач: 0</div>
        <div className={styles.header}>
          <span>Районы</span>
          <span>Кол-во вопросов</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.rightTableContainer}>
      <div className={styles.title}>Данные по районам</div>
      <Select
        placeholder="Выберите регион"
        style={{ width: "100%" }}
        onChange={onRegionClick}
        value={selectedRegionId || undefined}
        loading={polygonsLoading}
      >
        <Select.Option value={0}>Все регионы</Select.Option>
        {(polygonsData?.res as EntTerritorialsUnits[])?.map((region: EntTerritorialsUnits) => (
          <Select.Option key={region.id} value={region.id} label={region.nameRu}>
            {region.nameRu}
          </Select.Option>
        ))}
      </Select>
      <div className={styles.totalCount}>Всего задач: {data.res.totalTasks}</div>

      <div className={styles.header}>
        <span>Районы</span>
        <span>Кол-во вопросов</span>
      </div>

      <ul className={styles.districtList}>
        {data.res.data.map((area: RegionData) => (
          <li key={area.nameRu} className={styles.districtItem}>
            <div className={styles.districtHeader}>
              <button
                className={styles.expandButton}
                onClick={() => toggleArea(area.nameRu)}
              >
                {expandedAreas[area.nameRu] ? '−' : '+'}
              </button>
              <span className={styles.districtName}>{area.nameRu}</span>
              <span className={styles.questionCount}>
                {area.amount} ({area.percentageOfExecuted}% вып.поруч.)
              </span>
            </div>
            {expandedAreas[area.nameRu] && (
              <ul className={styles.categoryList}>
                {area.categoriesData.map((category: CategoryData) => (
                  <li key={category.nameRu} className={styles.categoryItem}>
                    <span>{category.nameRu}</span>
                    <span>{category.amount} ({category.percentageOfExecuted}% вып.поруч.)</span>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

const MapComponent: React.FC<{
  center: LatLngTuple;
  polygonsData: any;
  data: any;
  areaData: any;
  onRegionClick: (value: number, option: any) => void;
  selectedRegionName: string;
  onShowMore: (item: any) => void;
}> = ({ center, polygonsData, data, areaData, onRegionClick, selectedRegionName, onShowMore }) => {
  const map = useMap();
  const polygonLayersRef = useRef<{ [key: string]: L.Polygon }>({});

  useEffect(() => {
    if (!map || !polygonsData?.res) {
      console.warn('Map or polygons data not available');
      return;
    }

    const polygonsArray = Array.isArray(polygonsData.res) ? polygonsData.res : [polygonsData.res];

    Object.values(polygonLayersRef.current).forEach(layer => {
      layer.remove();
    });
    polygonLayersRef.current = {};

    polygonsArray.forEach((polygon: EntTerritorialsUnits) => {
      try {
        if (!polygon.polygonJson) return;

        const parsedPolygon = JSON.parse(polygon.polygonJson);
        if (!parsedPolygon || !Array.isArray(parsedPolygon) || !parsedPolygon[0]) return;

        const geoJson = parsedPolygon[0].geojson;
        if (!geoJson || !geoJson.coordinates || !Array.isArray(geoJson.coordinates)) return;

        const coordinates = geoJson.type === 'MultiPolygon'
          ? geoJson.coordinates[0][0]
          : geoJson.coordinates[0];

        if (!Array.isArray(coordinates)) return;

        const latLngs: LatLngTuple[] = coordinates.map((coord: number[]) => [coord[1], coord[0]]);

        const polygonLayer = L.polygon(latLngs, {
          color: polygon.nameRu === selectedRegionName ? '#2196F3' : 'rgba(77, 142, 33, 1)',
          fillColor: polygon.nameRu === selectedRegionName ? '#2196F3' : 'rgba(77, 142, 33, 1)',
          fillOpacity: polygon.nameRu === selectedRegionName ? 0.3 : 0.1,
          weight: polygon.nameRu === selectedRegionName ? 2 : 1
        })
          // .bindTooltip(polygon.nameRu, {
          //   permanent: false,
          //   direction: 'center',
          //   className: styles.tooltipCustom
          // })
          .addTo(map);

        polygonLayer.on('click', () => {
          Object.values(polygonLayersRef.current).forEach(layer => {
            layer.setStyle({
              color: 'rgba(77, 142, 33, 1)',
              fillColor: 'rgba(77, 142, 33, 1)',
              fillOpacity: 0.1,
              weight: 1
            });
          });

          polygonLayer.setStyle({
            color: 'rgba(77, 142, 33, 1)',
            fillColor: 'rgba(77, 142, 33, 1)',
            fillOpacity: 0.3,
            weight: 2
          });

          if (onRegionClick && polygon.id != null) {
            onRegionClick(polygon.id, polygon.nameRu);
          }
        });

        if (polygon.id != null) {
          polygonLayersRef.current[polygon.id.toString()] = polygonLayer;
        }
      } catch (error) {
        console.error(`Error processing polygon for ${polygon.nameRu}:`, error);
      }
    });

    if (Object.values(polygonLayersRef.current).length > 0) {
      const group = L.featureGroup(Object.values(polygonLayersRef.current));
      map.fitBounds(group.getBounds());
    }
  }, [map, polygonsData, selectedRegionName, onRegionClick]);

  const renderPolygons = () => {
    return (
      <TileLayer
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    );
  };

  const getIconByRegionId = (regionId: number): string => {
    const iconMap: { [key: number]: string } = {
      2: "/assets/icons_kurultai/kurul.svg",
      267: "/assets/icons_kurultai/kurul1.svg",
      825: "/assets/icons_kurultai/kurul2.svg",
      1035: "/assets/icons_kurultai/kurul3.svg",
      1296: "/assets/icons_kurultai/kurul4.svg",
      1931: "/assets/icons_kurultai/kurul5.svg",
      2067: "/assets/icons_kurultai/kurul6.svg",
    };
    return iconMap[regionId] || "/assets/icons_kurultai/kurul.svg";
  };

  const renderMarkers = () => {
    return (
      data?.res?.content?.map((item: KurultaiRegister) => (
        <Marker
          key={item.id}
          position={[item.latitude, item.longitude]}
          icon={L.icon({
            iconUrl: getIconByRegionId(item.region.id),
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
          })}
        >
          <Popup closeButton={false}>
            <PopupContent item={item} onShowMore={onShowMore} />
          </Popup>
        </Marker>
      ))
    );
  };

  return (
    <>
      {renderPolygons()}
      {renderMarkers()}
    </>
  );
};

export const KurultaiMap: React.FC<IContentPart> = ({
  latitude,
  longitude,
  polygonsData,
  data,
  areaData,
  onRegionClick,
  selectedRegionName,
  selectedRegionId,
  polygonsLoading
}) => {
  const mapRef = useRef<Map | null>(null);
  const [selectedItem, setSelectedItem] = useState<KurultaiRegister | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);

  const handleShowMore = (item: KurultaiRegister) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isModalOpen]);

  const center: LatLngTuple = [latitude, longitude];

  return (
    <>
      <div className={styles.mapContainer}>
        <MapContainer
          center={center}
          zoom={7}
          style={{ height: "100%", width: "100%" }}
          zoomControl={false}
          ref={mapRef}
        >
          {/* <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://core-renderer-tiles.maps.yandex.net/tiles?l=map&x={x}&y={y}&z={z}&apikey=760c9065-21b0-43d8-9cec-4ac31bbb794a"
          /> */}
          <ZoomControl position="bottomright" />
          <MapComponent
            center={center}
            polygonsData={polygonsData}
            data={data}
            areaData={areaData}
            onRegionClick={onRegionClick}
            selectedRegionName={selectedRegionName}
            onShowMore={handleShowMore}
          />
        </MapContainer>
        <RightTableComponent
          data={areaData}
          onRegionClick={onRegionClick}
          selectedRegionId={selectedRegionId}
          polygonsLoading={polygonsLoading}
          polygonsData={polygonsData}
        />
      </div>

      {isModalOpen && selectedItem && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent} ref={modalRef}>
            <button className={styles.closeButton} onClick={() => setIsModalOpen(false)}>×</button>
            <DetailContent item={selectedItem} />
          </div>
        </div>
      )}
    </>
  );
};